import { objectHasDefinedFields } from "../../util/objects/objects"
import { StringValidation } from "../../util/validation/string"
import { UpdateUserFormErrors } from "./types"
import { UpdateUserFormI } from "./types"

const getFormErrors = (form: UpdateUserFormI): UpdateUserFormErrors => {
    const errors: UpdateUserFormErrors = {
        firstName: undefined,
        lastName: undefined,
    }

    if (StringValidation.isEmpty(form.firstName)) {
        errors.firstName = "First name is required"
    }

    if (StringValidation.isEmpty(form.lastName)) {
        errors.lastName = "Last name is required"
    }

    return errors
}

/**
 * Checks if the form is valid.
 * @param form - The form to be checked.
 * @returns True if the form is valid, false otherwise.
 */
const isFormValid = (form: UpdateUserFormI): boolean => {
    const errors = getFormErrors(form)
    const hasErrors = objectHasDefinedFields(errors)
    // if there are errors, the form is not valid
    return !hasErrors
}

export { getFormErrors, isFormValid }
